import FinanceOptions from '@modules/financeOptions/components/FinanceOptions';
const Home = () => {
    return (<div className="text-gray-900">
            <FinanceOptions />
        </div>);
};
export default Home;
